import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { UtilsService } from '@geekeno/ngx-website/services';
import { environment } from '../../environments/environment';

export interface Blog {
  slug: string;
  title: string;
  cover_image: string;
  cover_bg_color: string;
  snippet: string;
  is_pinned: boolean;
  categories: string[];
  content?: string;
  author: {
    id: number;
    username: string;
    email: string;
    first_name: string;
    last_name: string;
  };
  timestamp: string;
  related_posts?: Blog[];
}

@Injectable({
  providedIn: 'root',
})
export class BlogService {
  private http = inject(HttpClient);
  private utils = inject(UtilsService);
  private readonly apiUrl: string;

  constructor() {
    this.apiUrl = this.utils.isPlatformServer
      ? `${environment.backendUrl}/api/blogs/`
      : `/api/blogs/`;
  }

  getBlogs(
    page: number,
    pageSize: number,
  ): Observable<{ results: Blog[]; next: string | null }> {
    return this.http.get<{ results: Blog[]; next: string | null }>(
      `${this.apiUrl}?page=${page}&size=${pageSize}`,
    );
  }

  getBlogBySlug(slug: string): Observable<Blog> {
    return this.http.get<Blog>(`${this.apiUrl}${slug}/`);
  }
}
